<template lang="pug"></template>

<script>
import BotaoRastreabilidadeGestaoBungeEmpresa from '@/components/botoesMenu/BotaoRastreabilidadeGestaoBungeEmpresa';
import BotaoRastreabilidadeDashboardBungeSubEmpresa from '@/components/botoesMenu/BotaoRastreabilidadeDashboardBungeSubEmpresa';
import BotaoConfiguracaoRastreabilidade from '@/components/botoesMenu/BotaoConfiguracaoRastreabilidade';

export default {
    name: 'BotaoRastreabilidadeBungeEmpresa',
    componentOptions: {
        title: 'RastreabilidadeEmpresa',
        actions: [
            [
                {
                    name: 'Rastreabilidade',
                    iconClass: 'lyra-icon bunge-rastreabilidade',
                    showView: false,
                    action: 'abrir',
                    route: 'RastreabilidadeEmpresa',
                    nameTranslationKey: 'mensagens.menuLateral.contratos',
                    submenus: [
                        BotaoRastreabilidadeGestaoBungeEmpresa,
                        BotaoRastreabilidadeDashboardBungeSubEmpresa,
                        BotaoConfiguracaoRastreabilidade
                    ]
                }
            ]
        ]
    },

    methods: {
        abrir() {
            if (this.$route.name !== 'RastreabilidadeEmpresa') {
                this.$router.push({ name: 'RastreabilidadeEmpresa' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
